/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    // covITProfessionals: {
    //     id: 'quoteandbind.PPLProLinedirectives.templates.ITProfessionals.Coverages',
    //     defaultMessage: 'Coverages'
    // },
    // formITProfessionals:{
    //     id: 'quoteandbind.PPLProLinedirectives.templates.ITProfessionals.Endorsements',
    //     defaultMessage: 'Endorsements'
    // }
});
